/** @prettier */

/**
 * フロア一覧
 */

import {useEffect, useState} from 'react';
import {Card, CardContent, Stack, Box} from '@mui/material';
import {useLocation, useParams, Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

//MTH component import
import CardContents from '../../component/CardContents';
//API import
import {getCompositionsSitesBySiteID} from '../../API/API_Collection';
//Style import
import '../../css/common/common.css';

import {useOutlet} from './FloorMain';

type FloorInfoType = {
  floor: string;
  groupNameList: string[];
}[];

const FloorRegistration = () => {
  //親コンポーネントから値を取得
  const {allGroupInfo} = useOutlet();
  //URL取得
  const location = useLocation();
  //パスパラメータ取得
  const {siteID} = useParams();

  const [floorInfo, setFloorInfo] = useState<FloorInfoType>([]); //フロアごとのグループ一覧

  const trans = useTranslation().t; //翻訳関数

  //サイトの情報を取得
  useEffect(() => {
    //パスパラメータを取得できない場合
    //グループの情報を取得できない場合
    if (siteID === undefined || allGroupInfo === null) {
      return;
    }

    getCompositionsSitesBySiteID(siteID).then(response => {
      //グループの名前を格納する配列をサイトに存在しているフロア分作成
      //フロアの順番を降順にする
      const temp: FloorInfoType = [
        ...Array(
          Math.abs(Number(response['under-ground'])) +
            Number(response['above-ground']) +
            1
        ),
      ]
        .map((_, i) => ({
          floor: String(i + Number(response['under-ground'])),
          groupNameList: [],
        }))
        .reverse();

      //グループの名前を格納
      for (const groupInfo of allGroupInfo['group-informations']) {
        if (groupInfo['group-name'] === undefined) continue;
        //格納場所を検索
        const index = temp.findIndex(info => info.floor === groupInfo['floor']);
        if (index === -1) continue;
        //格納
        temp[index].groupNameList.push(groupInfo['group-name']);
        //グループの名前をユニコード順に並び替え
        temp[index].groupNameList.sort();
      }

      setFloorInfo(temp);
    });
  }, [siteID, allGroupInfo]);

  return (
    <>
      <Box className="groupSetting__title">
        {trans('FloorRegistration.title')}
      </Box>
      <Stack spacing={5}>
        {/* フロア表示 */}
        {/* 最上階から順にフロア一覧を表示 */}
        {floorInfo.map(floorInfo => (
          <Card
            id={`floorBox-floor${floorInfo.floor}`}
            key={`floorBox-floor${floorInfo.floor}`}
            className="groupSetting__contents--floor">
            <CardContent>
              <Stack spacing={2}>
                {/** フロア名 */}
                <Box className="groupSetting__contents__title">
                  {Number(floorInfo.floor) < 0 ? (
                    //地下階
                    <Link
                      to={`${location.pathname}/${floorInfo.floor}/group-registration${location.search}`}
                      id={`mv-linkFloor${floorInfo.floor}`}>
                      {trans(
                        `FloorRegistration.linkTxt.floor.basement${Math.abs(
                          Number(floorInfo.floor)
                        )}`
                      )}
                    </Link>
                  ) : (
                    //地上階
                    <Link
                      to={`${location.pathname}/${floorInfo.floor}/group-registration${location.search}`}
                      className={`linkFloor${floorInfo.floor}`}
                      id={`mv-linkFloor${floorInfo.floor}`}>
                      {trans(
                        `FloorRegistration.linkTxt.floor.floor${floorInfo.floor}`
                      )}
                    </Link>
                  )}
                </Box>
                {/** フロア毎のグループ数と名前 */}
                <Stack spacing={2} className="groupSetting__contents__contents">
                  {/** グループ数 */}
                  <CardContents
                    class="groupSetting__contents__contents__underLine"
                    valueDescription={trans(
                      'FloorRegistration.item.title.numberOfGroups'
                    )}
                    value={String(floorInfo.groupNameList.length)}
                  />
                  {/* グループの名前 */}
                  <CardContents
                    class="groupSetting__contents__contents__underLine"
                    valueDescription={trans(
                      'FloorRegistration.item.title.groupName'
                    )}
                    value={
                      floorInfo.groupNameList.length === 0 ? (
                        <>
                          {trans('FloorRegistration.item.value.groupName.none')}
                        </>
                      ) : (
                        <Stack spacing={0}>
                          {floorInfo.groupNameList.map((name, index) => (
                            <Box key={`${name}${index}`}>{name}</Box>
                          ))}
                        </Stack>
                      )
                    }
                  />
                </Stack>
              </Stack>
            </CardContent>
          </Card>
        ))}
      </Stack>
    </>
  );
};
export default FloorRegistration;
